import script from "./SidenavItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SidenavItem.vue?vue&type=script&setup=true&lang=js"

import "./SidenavItem.vue?vue&type=style&index=0&id=39978b92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39978b92"]])

export default __exports__